import { formatISO } from 'date-fns';
import { useMemo } from 'react';
import {
  CollectionsForRanchesQueryArgs,
  useGetCollectionsForRanchesQuery,
} from '../../../services/entities/impl/blfApi/endpoints/ranches';
import { Ranch } from '../../../services/entities/impl/blfApi/schemas/ranch';
import { DateRangeFilter } from '../../commonUI/DateRangeFilterSelect/types';

export const useCollectionsFiltered = (
  ranchIds: Ranch['id'][] | undefined,
  dateRangeFilter?: DateRangeFilter | null
) => {
  // Construct query args
  const queryArgs = useMemo<CollectionsForRanchesQueryArgs>(() => {
    if (ranchIds) {
      return {
        ranchIds,
        collection_date__gte: dateRangeFilter?.start
          ? formatISO(dateRangeFilter.start, { representation: 'complete' })
          : undefined,
        collection_date__lte: dateRangeFilter?.end
          ? formatISO(dateRangeFilter.end, { representation: 'complete' })
          : undefined,
      };
    } else return { ranchIds: [] };
  }, [ranchIds, dateRangeFilter]);

  // Fetch list of collections by ranches
  const results = useGetCollectionsForRanchesQuery(queryArgs, {
    skip: !ranchIds,
  });

  return results;
};
